import { render } from "./PrefixPortal.vue?vue&type=template&id=f7c319d2&scoped=true"
import script from "./PrefixPortal.vue?vue&type=script&lang=js"
export * from "./PrefixPortal.vue?vue&type=script&lang=js"

import "./PrefixPortal.vue?vue&type=style&index=0&id=f7c319d2&scoped=true&lang=css"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7c319d2"]])

export default __exports__